import { ViewList } from '@mui/icons-material';
import { NavItemType } from 'types/menu';

const icons = {
  ViewList
};

// ==============================|| MENU ITEMS - FORMS & TABLES ||============================== //

const reports: NavItemType = {
  id: 'group-reports',
  title: 'Reports',
  icon: icons.ViewList,
  type: 'group',
  children: [
    {
      id: 'reports',
      title: 'Reports',
      type: 'collapse',
      icon: icons.ViewList,
      children: [
        {
          id: 'gigs',
          title: 'Gigs',
          type: 'item',
          url: '/reports/gigs'
        },
        {
          id: 'sales',
          title: 'Sales Events',
          type: 'item',
          url: '/reports/sales'
        },
        {
          id: 'sales-contacts',
          title: 'Sales Contacts',
          type: 'item',
          url: '/reports/sales-contacts'
        },
        {
          id: 'leads',
          title: 'Leads',
          type: 'item',
          url: '/reports/leads'
        },
        {
          id: 'deposits',
          title: 'Deposits',
          type: 'item',
          url: '/reports/deposits'
        },
        {
          id: 'expenses',
          title: 'Expenses',
          type: 'item',
          url: '/reports/expenses'
        },
        {
          id: 'ai-mail-reporting',
          title: 'AI Mail Reporting',
          type: 'item',
          url: '/reports/ai-mail-reporting'
        }
      ]
    }
  ]
};

export default reports;
